import { useState, useEffect } from 'react';
import { Login } from '../../features/login';
import { AuthLayout } from '../../layout';
import { PAGES_ANALYTICS_TITLES } from '../../utils/enums';
import { PageHelmet } from '../../components';
import { AuthBackgroundLayout } from '../../layout/auth/AuthBackgroundLayout';

function LoginPage() {
  const [isEmbedded, setIsEmbedded] = useState(true);

  useEffect(() => {
    setIsEmbedded(window !== window.parent);
  }, []);

  if (isEmbedded) {
    return (
      <AuthBackgroundLayout>
        <Login />
      </AuthBackgroundLayout>
    );
  }

  return (
    <PageHelmet title={PAGES_ANALYTICS_TITLES.LOGIN}>
      <AuthLayout>
        <Login />
      </AuthLayout>
    </PageHelmet>
  );
}

export default LoginPage;
